module.exports = __webpack_public_path__ + "static/media/emojis2_16.c504e4ac.svg";